import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { useLotSizingAddLineDialog } from '@/features/lot-sizing/hooks/use-lot-sizing-add-line-dialog';
import { LotSizingAddLineForm } from './lot-sizing-add-line-form';

type LotSizingTableAddLineDialogProps = {
  disabled?: boolean;
  lotSizingId: string;
};

export function LotSizingTableAddLineDialog({
  disabled = false,
  lotSizingId,
}: LotSizingTableAddLineDialogProps) {
  const { t } = useTranslation('lotSizing');
  const { open, onOpenChange, control, handleSubmit, onSubmit, isPending } =
    useLotSizingAddLineDialog(lotSizingId);

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogTrigger asChild>
        <Button disabled={disabled} variant='outline'>
          <PlusIcon className='h-4 w-4' />
          {t('Add a line')}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Add a line')}</DialogTitle>
          <DialogDescription>
            {t(
              'Add a product by SKU. The product must be produced by one of the suppliers in the lot sizing',
            )}
          </DialogDescription>
        </DialogHeader>
        <LotSizingAddLineForm
          control={control}
          handleSubmit={handleSubmit}
          isSubmitting={isPending}
          onSubmit={onSubmit}
        >
          <DialogClose asChild>
            <Button disabled={isPending} type='button' variant='outline'>
              {t('cancel', { ns: 'common' })}
            </Button>
          </DialogClose>
        </LotSizingAddLineForm>
      </DialogContent>
    </Dialog>
  );
}
